import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';
import classnames from 'classnames';
import Tablazat from './Tablazat';
import Naptar from './Naptar';

class IdopontfoglaloNaptarBase extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  hasRole = (roleName) => {
    return this.props.globals.hasRole(roleName);
  }

  componentDidMount() {
    this.checkRole();
  }

  checkRole = () => {
    //TODO default tab beállítása jogok alapján
  }

  render() {
    let cardStyle = {
      padding: 10
    };
    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Időpontfoglaló
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <Nav tabs>
                  {(this.hasRole(['IDOPONT'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '1' })}
                        onClick={() => { this.toggle('1'); }}
                      >
                        Naptár
                      </NavLink>
                    </NavItem>
                  : <div />}
                  {(this.hasRole(['IDOPONT'])) ?
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: this.state.activeTab === '2' })}
                        onClick={() => { this.toggle('2'); }}
                      >
                        Foglalások
                      </NavLink>
                    </NavItem>
                  : <div />}
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                  {(this.hasRole(['IDOPONT'])) ?
                    <TabPane tabId="1">
                      <Naptar {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                  : <div />}
                  {(this.hasRole(['IDOPONT'])) ?
                    <TabPane tabId="2">
                      <Tablazat {...this.props} globals={this.props.globals} activeTab={this.state.activeTab} />
                    </TabPane>
                  : <div />}
                </TabContent>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IdopontfoglaloNaptarBase;
